module.exports = __webpack_public_path__ + "img/attribute_mark_6_off.5c04c1b.png";